import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { supabase } from "../supabase/client";
import { userErrorMessage } from "../utils/userErrorMessage";
import "../App.css";

async function getRequestError(error) {
  const response = await error?.context?.clone?.().json().catch(() => null);
  return userErrorMessage(response?.error || error);
}

export default function SignupRequest() {
  const navigate = useNavigate();
  const [form, setForm] = useState({
    companyName: "",
    userName: "",
    email: "",
    password: "",
    passwordConfirm: "",
  });
  const [submitting, setSubmitting] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  const updateField = (field, value) => {
    setForm((current) => ({ ...current, [field]: value }));
    setErrorMessage("");
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (form.password !== form.passwordConfirm) {
      setErrorMessage("비밀번호와 비밀번호 확인이 일치하지 않습니다.");
      return;
    }
    if (form.password.length < 8) {
      setErrorMessage("비밀번호는 8자 이상 입력해 주세요.");
      return;
    }

    setSubmitting(true);
    setErrorMessage("");
    try {
      const { data, error } = await supabase.functions.invoke("signup-requests", {
        body: {
          action: "apply",
          companyName: form.companyName.trim(),
          userName: form.userName.trim(),
          email: form.email.trim(),
          password: form.password,
        },
      });
      if (error) throw error;
      if (!data?.requestId || !data?.checkoutToken) throw new Error("결제 화면으로 이동할 수 없습니다. 잠시 후 다시 시도해 주세요.");
      sessionStorage.setItem("busHubSignupCheckout", JSON.stringify({
        requestId: data.requestId,
        checkoutToken: data.checkoutToken,
      }));
      setForm((current) => ({ ...current, password: "", passwordConfirm: "" }));
      navigate("/subscription", { replace: true });
    } catch (error) {
      setErrorMessage(await getRequestError(error));
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="login-background min-h-screen flex items-center justify-center p-4">
      <form onSubmit={handleSubmit} className="bg-white bg-opacity-90 p-6 max-w-sm w-full rounded shadow-md space-y-3">
        <h1 className="text-lg font-bold">회원 가입 신청</h1>
        {[
          ["companyName", "회사명", "text"],
          ["userName", "사용자명", "text"],
          ["email", "이메일", "email"],
          ["password", "비밀번호", "password"],
          ["passwordConfirm", "비밀번호 확인", "password"],
        ].map(([field, label, type]) => (
          <label key={field} className="block text-sm font-medium">
            {label}
            <input
              className="mt-1 w-full border p-2"
              type={type}
              value={form[field]}
              onChange={(event) => updateField(field, event.target.value)}
              required
              maxLength={field === "email" ? 254 : field.startsWith("password") ? 128 : 100}
              autoComplete={field === "email" ? "email" : field.startsWith("password") ? "new-password" : "off"}
            />
          </label>
        ))}
        {errorMessage && <p role="alert" className="text-sm text-red-600">{errorMessage}</p>}
        <div className="flex items-center gap-3">
          <button className="bg-blue-600 text-white px-4 py-2 rounded disabled:opacity-50" disabled={submitting} type="submit">
            {submitting ? "신청 중..." : "신청"}
          </button>
          <Link className="text-sm text-blue-700" to="/login">로그인으로 돌아가기</Link>
        </div>
      </form>
    </div>
  );
}
